/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getQueryVariable } from "../../utils/query-utils";
import { WebLayout } from "../components/web-layout";
import { Spinner } from "../../components/Spinner";
import { loginFromSolera } from "../../actions/authentication";

export interface Props {
    location?: any;
    login: (code: string) => void;
}

function Page({ location, login }: Props) {
    const [loading, setLoading] = useState(true);
    const [errorText, setErrorText] = useState<string | undefined>(undefined);

    useEffect(() => {
        async function logins() {
            try {
                const code = getQueryVariable(
                    location.search as string,
                    "code"
                );
                if (!code) {
                    throw new Error("Code not found");
                }

                await login(code);
                window.location.href = "/app/dashboard";
            } catch {
                setLoading(false);
                const errorString = getQueryVariable(
                    location.search as string,
                    "error"
                );
                if (errorString === "access_denied") {
                    window.location.href =
                        "https://app.wellvolution.com/refusal";
                } else {
                    setErrorText("Could not login. Please try again");
                }
            }
        }

        void logins();
    }, [location, login]);

    return (
        <WebLayout>
            <div className="text-center mb-2">
                {loading && (
                    <span>
                        Logging in <Spinner />
                    </span>
                )}
                {errorText && <p className="alert alert-danger">{errorText}</p>}
            </div>
        </WebLayout>
    );
}

function mapStateToProps() {
    return {};
}

export const SoleraCallback = connect(mapStateToProps, {
    login: loginFromSolera,
})(Page);
